import { CircularProgress } from '@material-ui/core';
import { Table } from 'antd';
import { ExportIcon } from 'assets/icon/dynamic';
import {
  ChartTitle,
  ChartWrapper,
  ReportWrapper,
} from 'components/Report/styles';
import React, { useEffect, useState } from 'react';

import { Bar, Line } from 'react-chartjs-2';
import { shallowEqual, useSelector } from 'react-redux';
import { generateFrenchShades } from '../Report/utils';
import dayjs from 'dayjs';
// import ScreensaverReport from './ScreensaverReport';

const AnalyticReport = (props) => {
  const { analytics, loading, type, onExport, selectedType } = props;
  const INITIAL_STATE = {
    labels: [],
    datasets: [],
  };

  const [reportData, setReportData] = useState(INITIAL_STATE);

  const { dataTable } = useSelector(
    (state) => ({
      dataTable: state.analytic.rawData,
      loadingTable: state.analytic.loadingCalculate,
      screens: state.screens.list,
    }),
    shallowEqual
  );

  const existingKeys =
    selectedType === 'day'
      ? analytics?.datasets?.map((ds) => ds.label)
      : Array.from(
          new Set(Object.values(analytics).flatMap((day) => Object.keys(day)))
        );

  const options = {
    // events: [],
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    animation: {
      duration: 1,
      onComplete() {
        const chart = this;
        const { ctx } = chart;

        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';

        chart.data.datasets.forEach(function (dataset, i) {
          const meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach(function (bar, index) {
              if (dataset.data[index] > 0) {
                const data = dataset.data[index];
                ctx.font = 'bold 12pt roboto';
                ctx.fillText(data, bar.x, bar.y);
              }
            });
          }
        });
      },
    },
    maintainAspectRatio: false,
    layout: {
      padding: 20,
    },
    plugins: {
      legend: {
        position: 'bottom',
      },
      tooltip: {
        displayColors: true,
      },
      datalabels: {
        font: {
          size: 0,
        },
      },
    },
  };

  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Hourly Traffic Analytics',
      },
      datalabels: {
        display: true,
        align: 'top',
      },
    },
  };

  const optionsTC = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
      // yAxes: [
      //   {
      //     ticks: {
      //       beginAtZero: true,
      //     },
      //   },
      // ],
    },
    // animation: {
    //   duration: 1,
    //   onComplete() {
    //     const chartInstance = this.chart;
    //     const { ctx } = chartInstance;

    //     ctx.textAlign = 'center';
    //     ctx.textBaseline = 'bottom';

    //     this.data.datasets.forEach(function (dataset, i) {
    //       const meta = chartInstance.controller.getDatasetMeta(i);
    //       meta.data.forEach(function (bar, index) {
    //         if (dataset.data[index] > 0) {
    //           const data = dataset.data[index];
    //           const textwidth = ctx.measureText(data).width;
    //           ctx.fillStyle = bar._model.backgroundColor;
    //           ctx.font = 'bold 12pt roboto';
    //           ctx.fillText(data, bar._model.x - 20, bar._model.y);

    //           ctx.font = 'normal 12pt roboto';
    //           ctx.fillStyle = '#404040';
    //           ctx.fillText(' people', bar._model.x + textwidth, bar._model.y);
    //         }
    //       });
    //     });
    //   },
    // },
    interaction: {
      intersect: false,
    },
    plugins: {
      legend: {
        position: 'top',
        align: 'end',
        labels: {
          boxWidth: 15,
          borderRadius: 10,
          useBorderRadius: true,
          font: {
            weight: 'bold',
          },
        },
      },
      datalabels: {
        font: {
          size: 0,
        },
      },
    },
  };

  let columns;
  if (type === 'trafficcounter') {
    columns = [
      {
        title: '#',
        dataIndex: 'index',
        width: '10%',
        render: (text, record, index) => (
          <div className="table-name">{index + 1}</div>
        ),
      },
      {
        title: 'Location',
        dataIndex: 'location',
        width: '40%',
        render: (text, record) => <div className="table-name">{text}</div>,
      },
      {
        title: 'Total Human Count',
        dataIndex: 'data',
        width: '20%',
        render: (text, record) => (
          <div className="table-name">{text?.toLocaleString()}</div>
        ),
      },
    ];
  } else {
    columns = [
      {
        title: 'Total Action Counts',
        dataIndex: 'count',
        width: '10%',
        sorter: (a, b) => a.count - b.count,
        render: (text) => <div className="table-name">{text}</div>,
      },
      {
        title: '#select',
        dataIndex: 'select',
        width: '10%',
        sorter: (a, b) => a.select - b.select,
        render: (text) => <div className="table-name">{text}</div>,
      },
      {
        title: '#goTo',
        dataIndex: 'goto',
        width: '10%',
        sorter: (a, b) => a.goto - b.goto,
        render: (text) => <div className="table-name">{text}</div>,
      },

      {
        title: 'Label',
        dataIndex: 'name',
        width: '40%',
        render: (text) => <div className="table-name">{text}</div>,
      },
    ];
  }

  // const colorPallete = [
  //   '#2C82F6',
  //   '#BFD9FC',
  //   '#7FB1F9',
  //   '#C6DFFD',
  //   '#1F69D8',
  //   '#1B5DBB',
  // ];

  useEffect(() => {
    if (analytics && !loading) {
      if (
        selectedType === 'day' &&
        type === 'trafficcounter' &&
        analytics.datasets
      ) {
        const colorPallete = generateFrenchShades(analytics.datasets.length);

        const convertedLabels = analytics.labels.map((hourString) => {
          const [hour] = hourString.split(':');
          return `${String(Number(hour)).padStart(2, '0')}:00`;
        });

        setReportData({
          labels: convertedLabels,
          datasets: analytics.datasets.map((data, index) => ({
            ...data,
            backgroundColor: colorPallete[index],
            borderColor: colorPallete[index],
          })),
        });
      } else {
        // const actions = [];
        // Object.values(analytics).forEach((val) => {
        //   Object.keys(val).forEach((loc) => {
        //     console.log(loc, 'loc');
        //     if (actions.indexOf(loc) === -1) {
        //       actions.push(loc);
        //     }
        //   });
        // });
        const actions = Array.from(
          new Set(Object.values(analytics).flatMap((v) => Object.keys(v)))
        ).sort();

        const colorPallete = generateFrenchShades(actions.length);
        const colorMap = Object.fromEntries(
          actions.map((a, i) => [a, colorPallete[i]])
        );

        setReportData({
          labels:
            type === 'trafficcounter'
              ? Object.keys(analytics).slice(0, -1)
              : Object.keys(analytics),
          datasets: actions.map((action) => ({
            label: action,
            data:
              type === 'trafficcounter'
                ? Object.values(analytics)
                    .slice(0, -1)
                    .map((val) => val[action])
                : Object.values(analytics).map((val) => val[action]),
            backgroundColor: colorMap[action],
            borderColor: colorMap[action],
            stack: 'Stack 0',
            borderWidth: 1,
          })),
        });

        // setReportData({
        //   labels: Object.keys(analytics),
        //   datasets: actions.map((set, index) => {
        //     const color = colorPallete[index];
        //     // monthData.push({
        //     //   location: set,
        //     //   data: Object.values(analytics)
        //     //     .map((val) => val[set])
        //     //     ?.reduce((a, b) => (b ? a + b : a), 0),
        //     // });
        //     return {
        //       label: set,
        //       data: Object.values(analytics).map((val) => val[set]),
        //       borderWidth: 1,
        //       stack: 'Stack 0',
        //       backgroundColor: color,
        //       strokeColor: color,
        //     };
        //   }),
        // });
      }

      // let dataMonth = [];
      // dataMonth = locations.map((loc) => {
      //   return {
      //     location: loc.location,
      //     ratio: _.groupBy(loc.data, 'gender'),
      //   };
      // });
      // console.log(dataMonth, 'data month');
      // setDataTable(_.sortBy(dataMonth, ['location']));
    }
  }, [analytics]); // eslint-disable-line

  return (
    <div className="analytic-chart">
      {/* <div className="field-body"> */}

      {/* </div> */}
      <ReportWrapper>
        <ChartTitle>Analytics</ChartTitle>

        {/* <div className="selector">
          {locations && (
            <div className="m-2">
              <Select
                // defaultValue={loc}
                placeholder="Location"
                style={{ width: 120 }}
                onChange={(val) => {
                  setReportData();
                  setLoc(val);
                }}
                options={[
                  {
                    value: null,
                    label: 'All location',
                  },
                  ...locations.map((location) => {
                    return {
                      value: location,
                      label: location,
                    };
                  }),
                ]}
              />
            </div>
          )}
        </div> */}

        {/* <div className="field is-horizontal">
          <div className="field-label is-normal">
            <label className="label">{"Start Date"}</label>
          </div>
          <div className="field-label is-normal">
            <label className="label">{"End Date"}</label>
          </div>
        </div> */}
        {reportData && !loading ? (
          <ChartWrapper style={{ height: 400 }}>
            {selectedType === 'day' && type === 'trafficcounter' ? (
              <Line
                key={reportData.datasets.map((d) => d.label).join('-')}
                data={reportData}
                options={optionsLine}
              />
            ) : (
              <Bar
                key={reportData.datasets.map((d) => d.label).join('-')}
                data={reportData}
                width={100}
                height={250}
                options={type === 'trafficcounter' ? optionsTC : options}
              />
            )}
          </ChartWrapper>
        ) : (
          <CircularProgress />
        )}
      </ReportWrapper>
      {onExport && type !== 'trafficcounter' && (
        <div className="leaderboard-export">
          <button className="btn-outline-primary" onClick={onExport}>
            <ExportIcon color="#64D5D2" size={18} />
            Export Summary
          </button>
        </div>
      )}
      <Table
        columns={columns}
        dataSource={
          selectedType === 'day'
            ? dataTable
                ?.filter((row) => existingKeys?.includes(row.location))
                ?.sort((a, b) => b.data - a.data)
            : type === 'trafficcounter'
        ? dataTable?.sort((a, b) => b.data - a.data)
        : dataTable?.slice(0, -1).sort((a, b) => b.data - a.data)
        }
      />
    </div>
  );
};

export default AnalyticReport;
